import { render } from "./partsConstruction.vue?vue&type=template&id=37618bf2&scoped=true&ts=true"
import script from "./partsConstruction.vue?vue&type=script&lang=ts"
export * from "./partsConstruction.vue?vue&type=script&lang=ts"

import "./partsConstruction.vue?vue&type=style&index=0&id=37618bf2&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37618bf2"]])

export default __exports__